import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { CityService } from './city.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { faStar, faPlus  } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.sass']
})
export class CityComponent implements OnInit {
  faPlus=faPlus;
  page: number = 1;
  itemsPerPage = 5;
  totalItems:any;
  searchBy="";
  searchText:any;

  allCitiesList:any;


displayStyle_addCity = "none";

country=""
state="";
city="";

isVerified:any
closeResult: string;
constructor(private toastr:ToastrService,
              private spinner :NgxSpinnerService,
              private cityservice:CityService,
              private modalService: NgbModal
    ) { }

  ngOnInit(): void {
    this.getAllCity()
  }

  getAllCity(){
    this.spinner.show();       
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    : 0,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      //  "isDeleted": 2        // 2 for getting all users
    }
    this.cityservice.getAllCity(data).subscribe((result:any)=>{
      console.log('all cities  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allCitiesList = result.data
        this.totalItems = result.totalRecords;
      }else{
        this.allCitiesList = [];
      }
    })
  }

  gty(page: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :this.page-1,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    }
    this.cityservice.getAllCity(data).subscribe((result:any)=>{
      console.log('all cities  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allCitiesList = result.data
      }else{
        this.allCitiesList = [];
      }
    })
  }


  addCity(){
    this.spinner.show();
    let data = {
      country : this.country,
      state : this.state,
      city : this.city
    }
    this.cityservice.addCity(data).subscribe((result:any)=>{
      console.log("add city response " , result);
      this.spinner.hide();
      this.displayStyle_addCity = "none";
      this.country="";
      this.state=""
      this.city="";
      this.getAllCity()
      this.modalService.dismissAll()
      if(result.statusCode == 200){
        this.toastr.success(result.message);
      }else{
        this.toastr.warning(result.message);
      }
    })
  }

  getCity(address:any){
    console.log(address);
    if(address.address_components.length >= 4){
      this.city = address.name;
      this.country = address.address_components[3].long_name,
      this.state = address.address_components[2].long_name
    }else if(address.address_components.length == 3){
      this.city = address.name;
      this.country = address.address_components[2].long_name,
      this.state = address.address_components[1].long_name
    }else if(address.address_components.length == 6){
      this.country = address.address_components[4].long_name,
      this.state = address.address_components[3].long_name
      this.city = address.address_components[2].long_name
    }
  console.log(this.country , this.state , this.city)
  }
  

  // applyFilter(filterValue:any){
  //   console.log(filterValue);
  //   let filterValueLower = filterValue.toLowerCase();
  //        if(filterValue === '' ) {
  //            this.allCitiesList=this.allCitiesList_forFilter;
  //        } 
  //        else {
  //          this.allCitiesList = this.allCitiesList_forFilter.filter((employee:any) => employee.city.toLowerCase().includes(filterValueLower) || employee.state.toLowerCase().includes(filterValueLower))
  //         }
  // }

  search(){
    if(this.searchText != ''){
        let data = {
          "fieldName" :  this.searchBy,
          "searchText" :this.searchText 
        } 
        this.spinner.show();
        this.cityservice.searchCity(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.allCitiesList = result.data;
          }else{
            this.spinner.hide();
            this.toastr.error(result.message);
          }
          console.log(result)
        })
    }else{
      this.toastr.error('Please Fill Search text')
    }
  }


  getVerifyToggleData(value:any , data:any){
    console.log(value , data);
    this.spinner.show();
    let sendData = {
      "id" : data._id,
      "active" : value == true?1:0 
    }
    this.cityservice.updateCity(sendData).subscribe((result:any)=>{
      this.spinner.hide();
      if(result.statusCode == 200){
          this.toastr.success(result.message)
          this.spinner.hide()
          // this.getAllCity()
      }else{
        this.toastr.warning(result.message)
        this.spinner.hide()
        // this.getAllCity()
      }
    })
  }


  deleteCity(data:any){
    this.spinner.show();
    let sendData = {
      "id" : data._id,
      "isDeleted" : 1
    }
    this.cityservice.updateCity(sendData).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide();
        this.toastr.success("Deletd Successfully");
        this.getAllCity()
      }else{
        this.spinner.hide()
        this.toastr.success(result.message)
      }
    })
  }

  editCityName:any;
  editUserId:any;
  editCity(content6:any , data:any){
    this.openAddCityModal(content6);
    this.editCityName = data.city;
    this.editUserId = data._id;
  }


  updateCity(){
    this.spinner.show();
    let data = {
      "id" : this.editUserId,
      "city" : this.city,
      "state" : this.state,
      "country" : this.country
    }
    this.cityservice.updateCity(data).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide();
        this.toastr.success(result.message)
        this.getAllCity()
        this.modalService.dismissAll()
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
        this.modalService.dismissAll
      }
    })
  }

  openAddCityModal(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }






  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "City Report.xlsx");
   }
}
